import {CreateResultNode} from "../view-model";
import {cloneHierarchy} from "./cloneHierarchy";

export const updateResultNodes = (
  root: CreateResultNode,
  updated: CreateResultNode
): CreateResultNode => {
  const clone = cloneHierarchy(root);
  const findAndUpdateNode = (node: CreateResultNode): boolean => {
    if (node.caId === updated.caId) {
      node.dbaName = updated.dbaName;
      node.oeId = updated.oeId;
      node.status = updated.status;
      return true;
    }
    for (const child of node.children) {
      if (findAndUpdateNode(child)) {
        return true;
      }
    }
    return false;
  };
  findAndUpdateNode(clone);
  return clone;
};
